/* RAVEVAM 2026 · Live-Licht, Uhr, Lichtlauf, Kaufen. Ohne Bibliothek. Das Licht selbst setzt rv-head schon im <head>. */
(function () {
  'use strict';
  var root = document.documentElement;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LICHT = {
    aufgang: { zeit: '06:45', name: 'Aufgang' },
    tag: { zeit: '14:00', name: 'Tageslicht' },
    untergang: { zeit: '19:45', name: 'Untergang' },
    nacht: { zeit: '23:30', name: 'Nacht' }
  };
  var ORDER = ['aufgang', 'tag', 'untergang', 'nacht'];
  function lichtFuer(h) { return (h >= 5 && h < 10) ? 'aufgang' : (h >= 10 && h < 17) ? 'tag' : (h >= 17 && h < 21) ? 'untergang' : 'nacht'; }
  function pad(n) { return String(n).padStart(2, '0'); }
  function koeln() {
    try {
      var p = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var g = function (t) { return p.find(function (x) { return x.type === t; }).value; };
      return { h: +g('hour') % 24, m: +g('minute') };
    } catch (e) { var d = new Date(); return { h: d.getHours(), m: d.getMinutes() }; }
  }
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  function alle(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Live oder Vorschau */
  var vorschau = null;
  function anwenden() {
    var n = koeln(), live = pad(n.h) + ':' + pad(n.m);
    var licht = vorschau ? vorschau.licht : lichtFuer(n.h);
    root.dataset.licht = licht;
    root.classList.toggle('rv-vorschau', !!vorschau);
    alle('[data-rv-uhrzeit]').forEach(function (e) { e.textContent = vorschau ? vorschau.zeit : live; });
    alle('[data-rv-live]').forEach(function (e) {
      e.textContent = vorschau ? ('Vorschau ' + vorschau.zeit + '. ' + LICHT[licht].name + '.') : ('Köln, ' + live + '. Das Licht im Bild zeigt die Uhrzeit.');
    });
    var min = vorschau ? (vorschau.min != null ? vorschau.min : (+vorschau.zeit.slice(0, 2)) * 60 + (+vorschau.zeit.slice(3, 5))) : (n.h * 60 + n.m);
    var pos = (min / 1440 * 100).toFixed(2) + '%';
    alle('[data-rv-horizont]').forEach(function (h) { h.style.setProperty('--pos', pos); });
    alle('[data-rv-horizont-zeit]').forEach(function (e) { e.textContent = vorschau ? ('Vorschau ' + vorschau.zeit) : ('Köln ' + live); });
    alle('[data-rv-licht-wahl]').forEach(function (b) { b.setAttribute('aria-pressed', String(!!vorschau && b.dataset.rvLichtWahl === licht)); });
    try { document.dispatchEvent(new CustomEvent('rv:licht', { detail: { licht: licht, vorschau: !!vorschau, min: min } })); } catch (e) {}
  }

  /* Schnittstelle für den Zeitregler im Fuß (rv-bewegung.js): beliebige Minute zeigen oder zurück zu jetzt */
  window.rvLicht = {
    zeigeMinute: function (m) {
      if (m == null) { vorschau = null; }
      else { m = Math.max(0, Math.min(1439, Math.round(m))); var h = Math.floor(m / 60); vorschau = { licht: lichtFuer(h), zeit: pad(h) + ':' + pad(m % 60), min: m }; }
      anwenden();
    }
  };

  document.addEventListener('click', function (e) {
    var uhr = e.target.closest('[data-rv-uhr]');
    if (uhr) {
      var jetzt = lichtFuer(koeln().h);
      var akt = vorschau ? vorschau.licht : jetzt;
      var i = ORDER.indexOf(akt);
      var naechst = ORDER[(i + 1) % 4];
      if (vorschau && naechst === jetzt) vorschau = null;
      else vorschau = { licht: naechst, zeit: LICHT[naechst].zeit };
      anwenden();
      publish('rv_uhr', { licht: vorschau ? vorschau.licht : 'jetzt' });
      return;
    }
    var wahl = e.target.closest('[data-rv-licht-wahl]');
    if (wahl) {
      var k = wahl.dataset.rvLichtWahl;
      vorschau = (vorschau && vorschau.licht === k) ? null : { licht: k, zeit: LICHT[k].zeit };
      anwenden();
      return;
    }
    var korb = e.target.closest('[data-rv-korb-link]');
    if (korb && window.Shopify && Shopify.actions && Shopify.actions.openCart && document.querySelector('theme-drawer#cart-drawer')) {
      e.preventDefault();
      Shopify.actions.openCart();
      return;
    }
    var auf = e.target.closest('[data-rv-menue-auf]');
    var dlg = document.querySelector('[data-rv-menue]');
    if (auf && dlg) { dlg.showModal(); auf.setAttribute('aria-expanded', 'true'); return; }
    if (e.target.closest('[data-rv-menue-zu]') && dlg) { dlg.close(); return; }
    var mb = e.target.closest('[data-rv-minus],[data-rv-plus]');
    if (mb) {
      var inp = mb.parentNode.querySelector('input');
      var v = Math.min(9, Math.max(1, (+inp.value || 1) + (mb.hasAttribute('data-rv-plus') ? 1 : -1)));
      inp.value = v;
    }
  });
  var dlgM = document.querySelector('[data-rv-menue]');
  if (dlgM) dlgM.addEventListener('close', function () { alle('[data-rv-menue-auf]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); });

  /* Ankündigung wechseln */
  alle('[data-rv-ann]').forEach(function (ann) {
    var t = alle(':scope > span', ann); if (t.length < 2 || RM) return;
    var ai = 0;
    setInterval(function () { t[ai].setAttribute('aria-hidden', 'true'); ai = (ai + 1) % t.length; t[ai].removeAttribute('aria-hidden'); }, 4500);
  });

  /* Kopf-Linie beim Scrollen */
  var kopf = document.querySelector('[data-rv-kopf]');
  if (kopf) window.addEventListener('scroll', function () { kopf.classList.toggle('rv-gescrollt', window.scrollY > 10); }, { passive: true });

  /* Lichtlauf: Hover lässt die Karte einmal durch die vier echten Fotos laufen */
  alle('[data-rv-lauf]').forEach(function (k) {
    var t = null, i = 0;
    function schritt() { k.dataset.lauf = ORDER[i % 4]; i++; if (i > 4) { clearInterval(t); t = null; delete k.dataset.lauf; } }
    k.addEventListener('mouseenter', function () { if (RM || t) return; i = 0; schritt(); t = setInterval(schritt, 650); });
    k.addEventListener('mouseleave', function () { clearInterval(t); t = null; delete k.dataset.lauf; });
  });

  /* Warenkorb-Zähler im Kopf */
  function zaehler(n) {
    alle('[data-rv-cnt]').forEach(function (c) { c.textContent = n; c.classList.add('rv-hops'); setTimeout(function () { c.classList.remove('rv-hops'); }, 300); });
  }
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.promise && e.promise.then) e.promise.then(function (r) {
      var n = (r && r.cart && r.cart.totalQuantity != null) ? r.cart.totalQuantity : (r && r.detail && r.detail.itemCount);
      if (n != null) zaehler(n);
    }).catch(function () {});
  });

  /* Lichtpunkt fliegt zum Warenkorb */
  function flug(von) {
    if (RM) return Promise.resolve();
    var ziel = document.querySelector('[data-rv-korb-link]');
    if (!ziel || !von.getBoundingClientRect || !document.body.animate) return Promise.resolve();
    var a = von.getBoundingClientRect(), b = ziel.getBoundingClientRect();
    var f = document.createElement('span'); f.className = 'rv-flug'; document.body.appendChild(f);
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var anim = f.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px)' },
      { transform: 'translate(' + (x0 + x1) / 2 + 'px,' + (Math.min(y0, y1) - 80) + 'px)', offset: .5 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.6)' }
    ], { duration: 650, easing: 'cubic-bezier(.2,.7,.2,1)' });
    return anim.finished.then(function () { f.remove(); }, function () { f.remove(); });
  }

  /* Kaufen: echtes Formular, mit JS über die Standard-Aktion von Shopify (Horizon-Schublade aktualisiert sich selbst) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rv-kauf]');
    if (!form) return;
    var actions = window.Shopify && Shopify.actions;
    if (!actions || !actions.updateCart) return; /* ohne JS-Aktion: normales Absenden an /cart/add */
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var id = form.querySelector('[name="id"]').value;
    var q = Math.max(1, parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1);
    if (btn) { btn.disabled = true; btn.classList.add('rv-laedt'); }
    var sektion = form.closest('.shopify-section');
    publish('rv_schnellkauf', { variante: id, menge: q, abschnitt: sektion ? sektion.id : '' });
    Promise.all([
      actions.updateCart({ lines: [{ merchandiseId: String(id), quantity: q }] }, { event: { context: 'standard-action' } }),
      flug(btn || form)
    ]).then(function (r) {
      var res = r[0] || {};
      if (res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      if (res.cart && res.cart.totalQuantity != null) zaehler(res.cart.totalQuantity);
      if (actions.openCart) actions.openCart();
    }).catch(function (err) {
      console.warn('[rv] Kaufen über Standard-Aktion fehlgeschlagen, sende Formular normal.', err);
      form.submit();
    }).finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('rv-laedt'); } });
  });

  /* Produktseite: Kaufleiste unten, sobald der Kaufknopf aus dem Bild ist (mobil) */
  var haupt = document.getElementById('rv-kauf-haupt');
  var sk = document.querySelector('[data-rv-sticky-kauf]');
  if (haupt && sk && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        var an = !x.isIntersecting && x.boundingClientRect.top < 0;
        sk.classList.toggle('rv-an', an); sk.setAttribute('aria-hidden', String(!an));
        alle('button', sk).forEach(function (b) { b.tabIndex = an ? 0 : -1; });
      });
    }).observe(haupt);
  }

  anwenden();
  setInterval(function () { if (!vorschau) anwenden(); }, 15000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden && !vorschau) anwenden(); });
})();
